module.exports = __webpack_public_path__ + "media/assets/images/blog/fb-arch-small-236ffba961959144d95a951925d3f073.png";